"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toPDFData = exports.tribunalGLJobReferenceCaseMap = exports.GLTribunalJobType = void 0;
const __1 = require("../../..");
const types_1 = require("../../cases/types");
var GLTribunalJobType;
(function (GLTribunalJobType) {
    GLTribunalJobType["CreateStaevning"] = "CREATE_STAEVNING";
    GLTribunalJobType["ResendStaevning"] = "RESEND_STAEVNING";
    GLTribunalJobType["RegisterVerdict"] = "REGISTER_VERDICT";
    GLTribunalJobType["CreateFogedbegaering"] = "CREATE_FOGEDBEGAERING";
    GLTribunalJobType["ResendFogedbegaering"] = "RESEND_FOGEDBEGAERING";
    GLTribunalJobType["RegisterInsolvens"] = "REGISTER_INSOLVENS";
})(GLTribunalJobType || (exports.GLTribunalJobType = GLTribunalJobType = {}));
exports.tribunalGLJobReferenceCaseMap = {
    [GLTribunalJobType.CreateStaevning]: [types_1.TribunalCaseType.GLStaevning],
    [GLTribunalJobType.ResendStaevning]: [types_1.TribunalCaseType.GLStaevning],
    [GLTribunalJobType.RegisterVerdict]: [types_1.TribunalCaseType.GLStaevning],
    [GLTribunalJobType.CreateFogedbegaering]: [types_1.TribunalCaseType.GLFogedBegaering],
    [GLTribunalJobType.ResendFogedbegaering]: [types_1.TribunalCaseType.GLFogedBegaering],
    [GLTribunalJobType.RegisterInsolvens]: [types_1.TribunalCaseType.GLFogedBegaering],
};
const toPDFData = (staevningData) => {
    return Object.assign(Object.assign({}, staevningData), { courtFee: (0, __1.formatNumber)(staevningData.courtFee), interests: (0, __1.formatNumber)(staevningData.interests), totalAmount: (0, __1.formatNumber)(staevningData.totalAmount) });
};
exports.toPDFData = toPDFData;
//# sourceMappingURL=greenland.js.map